import edit_button from '../edit_button.html';

export default function (nga, admin) {
  const box = admin.getEntity('box');
  box.listView()
    .title('<h4>Box <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>')
    .batchActions([])
    .fields([
      nga.field('model', 'string')
        .label('Model'),
      nga.field('manufacturer', 'string')
        .label('Manufacturer'),
      nga.field('vendor', 'string')
        .label('Vendor'),
      nga.field('brand', 'string')
        .label('Brand'),
    ])
    .listActions(['edit', 'delete'])
    .exportFields([
        box.listView().fields(),
    ]);

    box.deletionView()
    .title('<h4>Box <i class="fa fa-angle-right" aria-hidden="true"></i> Delete <span style ="color:red;"> {{ entry.values.model }} </span></h4>')
    .actions(['<ma-back-button entry="entry" entity="entity"></ma-back-button>'])


    box.creationView()
    .title('<h4>Box <i class="fa fa-angle-right" aria-hidden="true"></i> Add Box </h4>')
    .fields([
      nga.field('model', 'string')
        .attributes({placeholder: 'Ex. IPB200'})
        .validation({required: true})
        .label('Model'),
      nga.field('manufacturer', 'string')
        .attributes({placeholder: ''})
        .validation({required: true})
        .label('Manufacturer'),
      nga.field('vendor', 'string')
        .attributes({placeholder: ''})
        .validation({required: true})
        .label('Vendor'),
      nga.field('brand', 'string')
        .attributes({placeholder: 'Ex. Google'})
        .validation({required: true})
        .label('Brand'),
      nga.field('template')
        .label('')
        .template(edit_button),
    ]);

    box.editionView()
    .title('<h4>Box <i class="fa fa-angle-right" aria-hidden="true"></i> Edit: {{ entry.values.model }}</h4>')
    .actions(['list'])
    .fields([
        box.creationView().fields(),
    ]);

  return box;

}



// WEBPACK FOOTER //
// ./js/box/config.js